import * as _firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDmXVuDfjn8VH4Ao08BgedtF5Oi8I91-E4",
  authDomain: "qserver-6e3b7.firebaseapp.com",
  databaseURL: "https://qserver-6e3b7.firebaseio.com",
  projectId: "qserver-6e3b7",
  storageBucket: "qserver-6e3b7.appspot.com",
  messagingSenderId: "519450867016"
};

export var firebase = _firebase.initializeApp(config);
